import React from 'react';
import { UnitInput } from './withFormProps';

const numberFormatter = new Intl.NumberFormat('de-DE');

export const UnitInputWrapper = ({
  unit,
  dotNotation = false,
  withGA4Event,
  ...props
}): JSX.Element => {
  const handleBlur = (amount) => {
    if (withGA4Event) {
      const googleAnalyticsObject = {
        event: 'select_amount',
        amount,
      };
      window?.dataLayer?.push(googleAnalyticsObject);
    }
  };
  return (
    <UnitInput
      {...props}
      unit={unit}
      value={
        dotNotation && props.value
          ? numberFormatter.format(props?.value)
          : props.value
      }
      onBlur={() => handleBlur(props?.value)}
    />
  );
};
